import { axiosRequest } from "../axios.config";

export const instructorCourseApi = {
  getMyCourses: async (params) => {
    const url = "Course/Get-all-my-course";
    const response = await axiosRequest.get(url, {
      params,
    });
    return response;
  },
  getMyPurchases: async (params) => {
    const url = "Course/Get-all-my-purchased";
    const response = await axiosRequest.get(url, {
      params,
    });
    console.log(response);
    return response;
  },
  getUpcomingCourses: async () => {
    const url = "Course/Get-all-up-coming-Course";
    const response = await axiosRequest.get(url);
    return response;
  },
  getDiscounts: async () => {
    const url = "Discount";
    const response = await axiosRequest.get(url);
    return response;
  },
  createDiscount: async (discount) => {
    const url = "Discount";
    const response = await axiosRequest.post(url, discount);
    // const response = await axiosRequest.post(url, discount);
    return response;
  },
  deleteDiscount: async (discountId) => {
    const url = `Discount?id=${discountId}`;
    const response = await axiosRequest.delete(url);
    // const response = await axiosRequest.post(url, discount);
    return response;
  },
};
